<template>
  
  <v-container grid-list-md fluid v-scroll="onScroll">

    <v-scale-transition>
      <v-btn
        transition="scale-transition"
        v-if="showScrollUp"
        color="primary"
        fab
        dark
        fixed
        bottom
        right
        small
        @click="scrollTo(0)"
      >
        <v-icon>fas fa-chevron-up</v-icon>
      </v-btn>
    </v-scale-transition>

    <v-fade-transition>
      <div class="white elevation-2 tripAdminHeader pa-2" v-if="showScrollUp">
        <v-layout row align-center>
          <v-flex xs4>
            <b>{{ trip.location_city }}, {{ trip.location_state }}</b> - {{ trip.checkin_date }} - {{ trip.checkout_date }}
          </v-flex>
          <v-flex xs4 class="text-xs-center"><b>{{ tripUser.first_name + ' ' + tripUser.last_name }}</b></v-flex>
          <v-flex xs4 class="text-xs-right">
            <v-btn small color="primary" @click="copyTripUrl()">Copy Trip Link</v-btn>
          </v-flex>
        </v-layout>
      </div>
    </v-fade-transition>

    <v-dialog
      v-model="inventoryDialog"
      max-width="1000"
      scrollable
      lazy
    >
      <v-card color="white">
        
        <v-card-title class="primary white--text text-xs-center" style="position: relative;">
          <v-btn
            absolute
            small
            fab
            top
            right
            flat
            color="white"
            style="top: 10px;"
            @click="inventoryDialog = false"
          ><v-icon>fas fa-times</v-icon></v-btn>
          <h3 style="margin: 0 auto;">Select Inventory</h3>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout row justify-center mb-4>
              <v-flex xs12 sm8 md6>
                <v-text-field
                  v-model="inventoryIdSearch"
                  label="Search By Supplier ID"
                  clearable
                  hide-details
                  append-outer-icon="fas fa-search"
                  @click:append-outer="filterInventory()"
                  @click:clear="filterInventory(true)"
                  @keyup.enter.native="getInventoryDataFromApi()"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-data-iterator
              :items="inventoryItems"
              :total-items="inventoryItemsTotal"
              :rows-per-page-items="[24]"
              :pagination.sync="inventoryItemsPagination"
              content-tag="v-layout"
              row
              wrap
            >
              <template v-slot:item="props">
                <v-flex 
                  xs6 
                  sm4 
                  md3 
                  lg2
                  :class="{'inventoryInLookbook':inventoryInLookbook(props.item._id)}" 
                  @click="toggleLookbookSelection(props.item)"
                  style="cursor: pointer;"
                >
                  <inventory-item :item="props.item"></inventory-item>
                </v-flex>
              </template>
            </v-data-iterator>
          </v-container>

        </v-card-text>
        <v-card-actions class="primary white--text">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="inventoryDialog = false">Close</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    
    
    <transition name="fade" mode="out-in" appear>
      <v-layout align-top row v-if="loading" key="loading">
        <v-flex>
          <div class="spinner" style="margin: 20px auto;">
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
          </div>
        </v-flex>
      </v-layout>

      <v-layout column v-else key="content">
        
        <v-flex>
          
          <v-layout row wrap>
            <v-flex class="text-xs-center">
              <h3 class="sans-serif">{{ trip.checkin_date }} - {{ trip.checkout_date }}</h3>
              <div class="body-2 mt-3">in <b>{{ trip.location_city }}, {{trip.location_state}}</b></div>
            </v-flex>
          </v-layout>
        
        </v-flex>
        <v-flex class="mt-3">
          <v-layout row>
            <v-flex md7>
              <v-card flat>
                <v-card-text>
                  <h5 class="sans-serif mb-3">User Information</h5>
                </v-card-text>
                <v-card-text class="my-0 py-0">

                  <v-layout row wrap class="mt-0 mb-4">
                    <v-flex md4>
                      <div class="field-label">First Name</div>
                      <v-text-field
                        readonly
                        flat
                        hide-details
                        class="pt-0"
                        :value="tripUser.first_name"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <div class="field-label">Last Name</div>
                      <v-text-field
                        readonly
                        flat
                        hide-details
                        class="pt-0"
                        :value="tripUser.last_name"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md2>
                      <div class="field-label">Dress Size</div>
                      <v-text-field
                        readonly
                        flat
                        hide-details
                        class="pt-0"
                        :value="tripFit.dress_size"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md2>
                      <div class="field-label">Waist Size</div>
                      <v-text-field
                        readonly
                        flat
                        hide-details
                        class="pt-0"
                        :value="tripFit.denim_waist_size"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap class="mt-0 mb-4">
                    <v-flex md4>
                      <div class="field-label">Email</div>
                      <v-text-field
                        readonly
                        flat
                        hide-details
                        class="pt-0"
                        :value="tripUser.email"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <div class="field-label">Birthday</div>
                      <v-text-field
                        readonly
                        flat
                        hide-details
                        class="pt-0"
                        :value="tripUser.birthday"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md2>
                      <div class="field-label">Top Size</div>
                      <v-text-field
                        readonly
                        flat
                        hide-details
                        class="pt-0"
                        :value="tripFit.top_size"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md2>
                      <div class="field-label">Pant Size</div>
                      <v-text-field
                        readonly
                        flat
                        hide-details
                        class="pt-0"
                        :value="tripFit.pant_size"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap class="mt-0 mb-0">
                    <v-flex md4>
                      <div class="field-label">Phone Number</div>
                      <v-text-field
                        readonly
                        flat
                        hide-details
                        class="pt-0"
                        :value="tripUser.phone"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md2>
                      <div class="field-label">Height</div>
                      <v-text-field
                        readonly
                        flat
                        hide-details
                        class="pt-0"
                        :value="tripFit.height_ft + ' \''"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md2>
                      <div class="field-label">&nbsp;</div>
                      <v-text-field
                        readonly
                        flat
                        hide-details
                        class="pt-0"
                        :value="inches(tripFit.height_in)"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md2>
                      <div class="field-label">Bra</div>
                      <v-text-field
                        readonly
                        flat
                        hide-details
                        class="pt-0"
                        :value="tripFit.bra_size"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md2>
                      <div class="field-label">Cup</div>
                      <v-text-field
                        readonly
                        flat
                        hide-details
                        class="pt-0"
                        :value="tripFit.bra_cup_size"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex md2>
              <v-card flat color="white" class="trip-wizard">
                <v-card-text>
                  <v-layout>
                    <v-flex
                      class="box-container pa-1 fitshape-container"
                    >
                      <v-hover>
                        <div
                          class="box-subcontainer pa-2"
                        >
                          <div 
                            class="img-container" 
                            :style="{backgroundImage: 'url(' + cdn + getFitImage(tripFit.body_shape) + ')'}"
                          >
                          </div>
                          <div class="label-container py-2" style="font-size: 1em;">{{ getFitLabel(tripFit.body_shape) }}</div>
                        </div> 
                      </v-hover>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex md3>
              <v-card flat color="grey lighten-4" style="height: 100%;">
                <v-card-text>
                  <v-layout row>
                    <v-flex><h5 class="sans-serif mb-3">Order</h5></v-flex>
                    <v-flex class="text-xs-right"><v-btn small color="primary" style="margin: -5px 0px 0px 0px;" @click="copyTripUrl()">Copy Trip Link</v-btn></v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-text class="mt-0 pt-0" v-if="!tripOrder || !tripOrder._id">
                  No Order Created Yet
                </v-card-text>
                <v-card-text class="mt-0 pt-0" v-else>
                  
                  <div class="field-label">Status</div>
                  <v-select
                    v-model="tripOrder.status"
                    solo
                    flat
                    hide-details
                    :items="orderStatuses"
                    
                  ></v-select>

                  <div class="field-label mt-3">Tracking #</div>
                  <v-text-field
                    v-model="trip.tracking_number"
                    solo
                    flat
                    hide-details
                    
                  ></v-text-field>

                  <div class="text-xs-center mt-3">
                    <v-btn color="primary" @click="updateOrder" :loading="orderSaving">UPDATE</v-btn>
                  </div>
                  
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex mt-4 class="grey lighten-4">
          <v-layout row>
            <v-flex>
              <v-card flat color="transparent" class="trip-wizard">
                <v-card-text>
                  <h5 class="sans-serif mb-3">Style Preferences</h5>
                </v-card-text>

                <v-card-text>
                  <v-layout row wrap>
                    <v-flex md6 class="pr-2">
                      <v-layout column>
                        <v-flex class="py-2 elevation-2 white" style="border-bottom: 1px solid rgba(0,0,0,.2);">
                          <div class="field-label">Current Style</div>
                          <v-layout row wrap>
                            <v-flex
                              v-for="(style, stylesIndex) in tripStyle.current_style"
                              :key="style + stylesIndex"
                              class="box-container pa-1 stylecurrent-container"
                              style="cursor: default;"
                              md3
                            >
                              <div 
                                class="box-subcontainer pa-2"
                              >
                                <div 
                                  class="style-img-container"                               
                                  :style="{backgroundImage: 'url(' + cdn + getStyleImage('current_style', style) + ')'}"
                                >
                                </div>
                                <div class="label-container py-2" style="font-size: 1em;">{{ getStyleLabel('current_style', style) }}</div>
                              </div> 
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex md5 class="py-2 mt-3 elevation-2 white" style="border-bottom: 1px solid rgba(0,0,0,.2);">
                          <div class="field-label">Avoid Colors</div>
                          <v-layout row wrap>
                            <v-flex
                              v-for="(color, colorIndex) in tripStyle.colors_avoid"
                              :key="'color-' + color"
                              :data-index="colorIndex"
                              class="color-container"
                              
                            >
                              
                              <div 
                                class="color-subcontainer" 
                                :style="{backgroundColor: getStyleColor(color)}"
                                :class="{['color-' + color]: true}"
                                style="cursor: default;"
                              >
                              </div>
                              <div class="text-container">{{ color.charAt(0).toUpperCase() + color.substring(1) }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex class="py-2 elevation-2 white mt-3" style="border-bottom: 1px solid rgba(0,0,0,.2);">
                          <div class="field-label">Patterns to Avoid</div>
                          <v-layout row wrap>
                            <v-flex
                              v-for="(pattern, patternIndex) in tripStyle.patterns_avoid"
                              :key="pattern + patternIndex"
                              class="box-container pa-1 "
                              style="cursor: default;"
                              md3
                            >
                              <div 
                                class="box-subcontainer pa-2"
                              >
                                <div 
                                  class="style-img-container"                               
                                  :style="{backgroundImage: 'url(' + cdn + getStyleImage('patterns_avoid', pattern) + ')'}"
                                >
                                </div>
                                <div class="label-container py-2" style="font-size: 1em;">{{ getStyleLabel('patterns_avoid', pattern) }}</div>
                              </div> 
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex class="py-2 elevation-2 white mt-3" style="border-bottom: 1px solid rgba(0,0,0,.2);">
                          <div class="field-label">Neckline Preference</div>
                          <v-layout row wrap>
                            <v-flex
                              v-for="(neckline, necklineIndex) in tripStyle.necklines"
                              :key="neckline + necklineIndex"
                              class="box-container pa-1 "
                              style="cursor: default;"
                              md3
                            >
                              <div 
                                class="box-subcontainer pa-2"
                              >
                                <div 
                                  class="style-img-container"                               
                                  :style="{backgroundImage: 'url(' + cdn + getStyleImage('necklines', neckline) + ')'}"
                                >
                                </div>
                                <div class="label-container py-2" style="font-size: 1em;">{{ getStyleLabel('necklines', neckline) }}</div>
                              </div> 
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex class="py-2 elevation-2 white mt-3" style="border-bottom: 1px solid rgba(0,0,0,.2);">
                          <div class="field-label">Top Fit Preference</div>
                          <v-layout row wrap>
                            <v-flex
                              v-for="(top, topIndex) in tripStyle.top_half_fit"
                              :key="top + topIndex"
                              class="box-container pa-1 styletop-container"
                              style="cursor: default;"
                              md3
                            >
                              <div 
                                class="box-subcontainer pa-2"
                              >
                                <div 
                                  class="style-img-container"                               
                                  :style="{backgroundImage: 'url(' + cdn + getStyleImage('top_half_fit', top) + ')'}"
                                >
                                </div>
                                <div class="label-container py-2" style="font-size: 1em;">{{ getStyleLabel('top_half_fit', top) }}</div>
                              </div> 
                            </v-flex>
                          </v-layout>
                        </v-flex>

                      </v-layout>
                    </v-flex>
                    <v-flex md6 class="pl-2">
                      <v-layout column>
                        <v-flex md5 class="py-2 elevation-2 white" style="border-bottom: 1px solid rgba(0,0,0,.2);">
                          <div class="field-label">Dress Style</div>
                          <v-layout row wrap>
                            <v-flex
                              v-for="(style, stylesIndex) in tripStyle.dress_style"
                              :key="style + stylesIndex"
                              class="box-container pa-1 styledress-container"
                              style="cursor: default;"
                              md3
                            >
                              <div 
                                class="box-subcontainer pa-2"
                              >
                                <div 
                                  class="style-img-container"                               
                                  :style="{backgroundImage: 'url(' + cdn + getStyleImage('dress_style', style) + ')'}"
                                >
                                </div>
                                <div class="label-container py-2" style="font-size: 1em;">{{ getStyleLabel('dress_style', style) }}</div>
                              </div> 
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex md5 class="py-2 mt-3 elevation-2 white" style="border-bottom: 1px solid rgba(0,0,0,.2);">
                          <div class="field-label">Pant Fit</div>
                          <v-layout row wrap>
                            <v-flex
                              v-for="(fit, fitIndex) in tripStyle.pant_fit"
                              :key="fit + fitIndex"
                              class="box-container pa-1 stylepant-container"
                              style="cursor: default;"
                              md3
                            >
                              <div 
                                class="box-subcontainer pa-2"
                              >
                                <div 
                                  class="style-img-container"                               
                                  :style="{backgroundImage: 'url(' + cdn + getStyleImage('pant_fit', fit) + ')'}"
                                >
                                </div>
                                <div class="label-container py-2" style="font-size: 1em;">{{ getStyleLabel('pant_fit', fit) }}</div>
                              </div> 
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex md5 class="py-2 mt-3 elevation-2 white" style="border-bottom: 1px solid rgba(0,0,0,.2);">
                          <div class="field-label">Sleeve Preference</div>
                          <v-layout row wrap>
                            <v-flex
                              v-for="(sleeve, sleeveIndex) in tripStyle.sleeve_preference"
                              :key="sleeve + sleeveIndex"
                              class="box-container pa-1"
                              style="cursor: default;"
                              md3
                            >
                              <div 
                                class="box-subcontainer pa-2"
                              >
                                <div 
                                  class="style-img-container"                               
                                  :style="{backgroundImage: 'url(' + cdn + getStyleImage('sleeve_preference', sleeve) + ')'}"
                                >
                                </div>
                                <div class="label-container py-2" style="font-size: 1em;">{{ getStyleLabel('sleeve_preference', sleeve) }}</div>
                              </div> 
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex md5 class="py-2 mt-3 elevation-2 white" style="border-bottom: 1px solid rgba(0,0,0,.2);">
                          <div class="field-label">Avoid</div>
                          <v-layout row wrap>
                            <v-flex
                              v-for="(avoid, avoidIndex) in tripStyle.items_avoid"
                              :key="avoid + avoidIndex"
                              class="box-container pa-1"
                              style="cursor: default;"
                              md3
                            >
                              <div 
                                class="box-subcontainer pa-2"
                              >
                                <div 
                                  class="style-img-container"                               
                                  :style="{backgroundImage: 'url(' + cdn + getStyleImage('items_avoid', avoid) + ')'}"
                                >
                                </div>
                                <div class="label-container py-2" style="font-size: 1em;">{{ getStyleLabel('items_avoid', avoid) }}</div>
                              </div> 
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex md5 class="py-2 mt-3 elevation-2 white" style="border-bottom: 1px solid rgba(0,0,0,.2);">
                          <div class="field-label">Conceal</div>
                          <v-layout row wrap>
                            <v-flex
                              v-for="(conceal, concealIndex) in tripStyle.areas_conceal"
                              :key="conceal + concealIndex"
                              class="box-container pa-1"
                              style="cursor: default;"
                              md3
                            >
                              <div 
                                class="box-subcontainer pa-2"
                              >
                                <div 
                                  class="style-img-container"                               
                                  :style="{backgroundImage: 'url(' + cdn + getStyleImage('areas_conceal', conceal) + ')'}"
                                >
                                </div>
                                <div class="label-container py-2" style="font-size: 1em;">{{ getStyleLabel('areas_conceal', conceal) }}</div>
                              </div> 
                            </v-flex>
                          </v-layout>
                        </v-flex>

                      </v-layout>
                    </v-flex>
                  </v-layout>


                </v-card-text>

              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex mt-4 class="white">
          <v-layout row>
            <v-flex md6>
              <v-card flat color="transparent" class="trip-wizard">
                <v-card-text>
                  <h5 class="sans-serif mb-3">Trip Details</h5>
                </v-card-text>

                <v-card-text>
                  <v-layout row wrap>
                    <v-flex
                      class="box-container pa-1"
                      style="cursor: default;"
                      md4
                    >
                      <div 
                        class="box-subcontainer pa-2"
                      >
                        <div 
                          class="style-img-container"                               
                          :style="{backgroundImage: 'url(' + cdn + getTripImage('location_types', trip.location_type) + ')'}"
                        >
                        </div>
                        <div class="label-container py-2" style="font-size: 1em;">{{ getTripLabel('location_types', trip.location_type) }}</div>
                      </div> 
                    </v-flex>
                    <v-flex md4>
                      <v-layout column>
                        <v-flex class="mb-2">
                          <div class="field-label pb-0 mb-0">
                            <span v-if="trip.location_type == 'ship'">Name</span>
                            <span v-else>Reservation Name</span>
                          </div>
                          <v-text-field
                            readonly
                            flat
                            hide-details
                            class="pt-0 mt-0"
                            :value="trip.reservation_name"
                          ></v-text-field>
                        </v-flex>
                        <v-flex class="mb-2">
                          <div class="field-label pb-0 mb-0">Checkin Date</div>
                          <v-text-field
                            readonly
                            flat
                            hide-details
                            class="pt-0 mt-0"
                            :value="trip.checkin_date"
                          ></v-text-field>
                        </v-flex>
                        <v-flex>
                          <div class="field-label pb-0 mb-0">Checkout date</div>
                          <v-text-field
                            readonly
                            flat
                            hide-details
                            class="pt-0 mt-0"
                            :value="trip.checkout_date"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      
                    </v-flex>
                    <v-flex md4>
                      <v-layout column>
                        <v-flex class="mb-2" v-if="trip.location_name">
                          <div class="field-label pb-0 mb-0">
                            <span v-if="trip.location_type == 'airbnb'">Host Name</span>
                            <span v-else>Hotel Name</span>
                          </div>
                          <v-text-field
                            readonly
                            flat
                            hide-details
                            class="pt-0 mt-0"
                            :value="trip.location_name"
                          ></v-text-field>
                        </v-flex>
                        <v-flex class="mb-2">
                          <div class="field-label pb-0 mb-0">Address</div>
                          <v-text-field
                            readonly
                            flat
                            hide-details
                            class="pt-0 mt-0"
                            :value="trip.location_address"
                          ></v-text-field>
                        </v-flex>
                        <v-flex>
                          <div class="field-label pb-0 mb-0">City, State, Zip</div>
                          <v-text-field
                            readonly
                            flat
                            hide-details
                            class="pt-0 mt-0"
                            :value="trip.location_city + ', ' + trip.location_state + ' ' + trip.location_zip"
                          ></v-text-field>
                        </v-flex>
                      </v-layout> 
                    </v-flex>

                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex md6>
              <v-card flat color="transparent" class="trip-wizard">
                <v-card-text>
                  <h5 class="sans-serif mb-3">Trip Purpose</h5>
                </v-card-text>

                <v-card-text>
                  <v-layout row wrap>
                    <v-flex
                      v-for="(purpose, purposeIndex) in trip.occasion_type"
                      :key="purpose + purposeIndex"
                      class="box-container pa-1"
                      style="cursor: default;"
                      md3
                    >
                      <div 
                        class="box-subcontainer pa-2"
                      >
                        <div 
                          class="style-img-container"                               
                          :style="{backgroundImage: 'url(' + cdn + getTripImage('occasion_types', purpose) + ')'}"
                        >
                        </div>
                        <div class="label-container py-2" style="font-size: 1em;">{{ getTripLabel('occasion_types', purpose) }}</div>
                      </div> 
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        
        
        <v-flex mt-4 class="grey lighten-4">
          <v-layout row>
            <v-flex xs12>

              <v-card flat color="transparent">
                <v-card-text>
                  <v-layout row>
                    <v-flex md12>
                      <h5 class="sans-serif mb-3">Lookbook</h5>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-card-text>
                  <v-container grid-list-md ma-0 pa-0>
                    

                      <draggable class="layout row wrap" v-model="tripInventory" group="inventory" @start="drag=true" @end="drag=false" handle=".inventory-drag-box">
                        <v-flex
                          v-for="inv in tripInventory" 
                          :key="inv._id"
                          md3
                          
                        >
                          <inventory-item 
                            :item="inv" 
                            draggable
                            :style="{border: (tripLookbook && tripLookbook.user_selected && tripLookbook.user_selected.indexOf(inv._id) >= 0 ? '3px solid #000' : '')}"
                          ></inventory-item>
                          <div>
                            <v-layout row mt-1>
                              <v-flex>{{ supplierName(inv.supplier_id) }}</v-flex>
                              <v-flex class="text-xs-right">{{ inv.item_id }}</v-flex>
                            </v-layout>
                          </div>
                          <div class="text-xs-center">
                            <!--<v-btn color="primary" @click="openInventory(inv._id)">Edit</v-btn>-->
                            <v-btn 
                              flat 
                              color="primary" 
                              style="min-width: 0px;"
                              @click="confirmRemoveInventory(inv)"
                            ><v-icon style="font-size: 1em;" class="mr-2">fas fa-trash</v-icon> Remove</v-btn>
                          </div>
                        </v-flex>
                      </draggable>

                  </v-container>
                </v-card-text>

                <v-card-text class="text-xs-center" v-if="!tripLookbook || tripInventory.length == 0">
                  <span>There are currently no items in the users lookbook</span>
                </v-card-text>

                <v-card-text class="text-xs-center">
                  <v-layout my-2 justify-center row>
                    <v-flex shrink>
                      <div class="field-label">Lookbook Status</div>
                      <v-select
                        v-model="tripLookbook.status"
                        hide-details 
                        solo
                        flat
                        :items="lookbookStatuses"
                      ></v-select>
                    </v-flex>
                  </v-layout>

                  <v-btn flat color="primary" @click="inventoryBrowser()" :disabled="lookbookSaving">Add Item</v-btn>
                  <v-btn color="primary" @click="saveLookbook()" :saving="lookbookSaving">Save Lookbook</v-btn>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>


      </v-layout>


    </transition>

  </v-container>

</template>

<script>
import styleOptions from '@/consts/styleOptions';
import fitOptions from '@/consts/fitOptions';
import tripOptions from '@/consts/tripOptions';

import InventoryItem from '@/components/helpers/InventoryItem';
import Draggable from 'vuedraggable';

export default {
  name: 'AdminTrip',
  components: {
    'inventory-item': InventoryItem,
    'draggable': Draggable
  },
  data () {
    return {
      trip: null,
      tripUser: null,
      tripStyle: null,
      tripFit: null,
      tripOrder: null,
      tripLookbook: null,
      tripInventory: null,

      inventoryDialog: false,
      inventoryIdSearch: null,
      inventoryEditing: {},
      inventorySaving: false,

      inventoryItems: [],
      inventoryItemsLoading: false,
      inventoryItemsTotal: 0,
      inventoryItemsPagination: {},

      orderSaving: false,

      lookbookSaving: false,

      showScrollUp: false,

      styleOptions: JSON.parse(JSON.stringify(styleOptions)),
      fitOptions: JSON.parse(JSON.stringify(fitOptions)),
      tripOptions: JSON.parse(JSON.stringify(tripOptions)),

      suppliers: [],

      orderStatuses: [
        {text:'Creating',value:'creating'},
        {text:'Rented',value:'rented'},
        {text:'Shipping',value:'shipping'},
        {text:'Return',value:'return'},
        {text:'Done',value:'done'}
      ],
      lookbookStatuses: [
        {text:'Creating',value:'creating'},
        {text:'Styling',value:'styling'},
        {text:'Done',value:'done'}
      ]
    }
  },
  watch: {
    '$route': function(newVal, oldVal) {
      if(newVal.params.trip_id != oldVal.params.trip_id) this.getDataFromApi();
    },
    inventoryItemsPagination: {
      handler () {
        this.getInventoryDataFromApi();
      },
      deep: true
    }
  },
  mounted: function() {
    this.getDataFromApi();
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    },
    trip_id: function() {
      return this.$route.params.trip_id;
    },
    loading: function() {
      return (!this.trip || !this.tripUser || !this.tripLookbook || !this.tripInventory || !this.tripOrder || !this.tripFit || !this.tripStyle);
    }
  },
  methods: {
    getInventoryDataFromApi: function() {
      this.inventoryItemsLoading = true;
      var { sortBy, descending, page, rowsPerPage } = this.inventoryItemsPagination;
      if(!page) page = 1;
      if(!rowsPerPage) rowsPerPage = 24;
      let append = '';
      if(this.inventoryIdSearch) append = '&item_id=' + this.inventoryIdSearch;
      this.$http.get('inventories?page=' + page + '&limit=' + rowsPerPage + append)
        .then(response => {
          this.inventoryItemsTotal = response.data.items.total;
          this.inventoryItems = response.data.data;
        })
        .catch(error => {

        })
        .finally( () => {
          this.inventoryItemsLoading = false;
        });
    },

    getDataFromApi: function() {
      this.trip = null;
      this.tripUser = null;
      this.tripStyle = null;
      this.tripFit = null;
      this.tripOrder = null;
      this.tripLookbook = null;
      this.tripInventory = null;

      this.$http.get('suppliers')
        .then(supplierResponse => {
          this.suppliers = supplierResponse.data.data;
        })
        .catch(supplierError => {this.apiLoadError});

      this.$http.get('trips/' + this.trip_id) 
        .then(tripResponse => {
          this.trip = tripResponse.data;

          this.$http.get('users/' + this.trip.user_id)
            .then(userResponse => {
              this.tripUser = userResponse.data;
            })
            .catch(userError => { this.apiLoadError });
          
          this.$http.get('users/' + this.trip.user_id + '/style')
            .then(styleResponse => {
              this.tripStyle = styleResponse.data;
            })
            .catch(styleError => { this.apiLoadError });

          this.$http.get('users/' + this.trip.user_id + '/fit')
            .then(fitResponse => {
              this.tripFit = fitResponse.data;
            })
            .catch(fitError => { this.apiLoadError });

          if(this.trip.lookbook_id) {
            this.$http.get('lookbooks/' + this.trip.lookbook_id + '/inventory')
              .then(lookbookResponse => {

                let inventory = JSON.parse(JSON.stringify(lookbookResponse.data[0].inventory_docs));
                delete lookbookResponse.data[0].inventory_docs;
                this.tripLookbook = lookbookResponse.data[0];

                //Function ensures tripInventory is loaded in the order returned by the lookbook array
                this.tripInventory = [];
                for(let lb_i1 = 0; lb_i1 < this.tripLookbook.inventory_id.length; lb_i1++) {
                  let temp_id = this.tripLookbook.inventory_id[lb_i1];
                  for(let lb_i2 = 0; lb_i2 < inventory.length; lb_i2++) {
                    if(inventory[lb_i2]._id == temp_id) {
                      this.tripInventory.push(inventory[lb_i2]);
                      break;
                    }
                  }
                }

                if(this.tripLookbook.order_id) {
                  this.$http.get('orders/' + this.tripLookbook.order_id)
                    .then(orderResponse => {
                      this.tripOrder = orderResponse.data;
                    })
                    .catch(orderError => {This.apiLoadError() });
                } else {
                  this.tripOrder = {};
                }
              })
              .catch(lookbookError => { this.apiLoadError() });
          } else {
            this.tripLookbook = {status: 'creating'};
            this.tripInventory = [];
            this.tripOrder = {};
          }
        })
        .catch(tripError => { this.apiLoadError(); });
    },
    apiLoadError: function() {
      this.$swal.fire('Error', 'There was an error loading the trip data');
      this.$router.go(-1);
    },
    inches: function(inches) {
      return inches + ' "';
    },
    supplierName: function(id) {
      for(let i = 0; i < this.suppliers.length; i++) {
        if(this.suppliers[i]._id == id) return this.suppliers[i].supplier_name;
      }
      return '';
    },

    getStyleImage: function(key, value) {
      for(let i = 0; i < this.styleOptions[key].length; i++) {
        if(this.styleOptions[key][i].key == value) return this.styleOptions[key][i].image;
      }
    },
    getStyleLabel: function(key, value) {
      for(let i = 0; i < this.styleOptions[key].length; i++) {
        if(this.styleOptions[key][i].key == value) return this.styleOptions[key][i].label;
      }
    },
    getStyleColor: function(value) {
      for(let i = 0; i < this.styleOptions.colors_avoid.length; i++) {
        if(this.styleOptions.colors_avoid[i].key == value) return this.styleOptions.colors_avoid[i].color;
      }
    },

    getFitImage: function(shape) {
      for(let i = 0; i < this.fitOptions.body_shapes.length; i++) {
        if(this.fitOptions.body_shapes[i].key == shape) return this.fitOptions.body_shapes[i].image;
      }
    },
    getFitLabel: function(shape) {
      for(let i = 0; i < this.fitOptions.body_shapes.length; i++) {
        if(this.fitOptions.body_shapes[i].key == shape) return this.fitOptions.body_shapes[i].label;
      }
    },

    getTripImage: function(key, val) {
      for(let i = 0; i < this.tripOptions[key].length; i++) {
        if(this.tripOptions[key][i].key == val) return this.tripOptions[key][i].image;
      }
    },
    getTripLabel: function(key, val) {

      for(let i = 0; i < this.tripOptions[key].length; i++) {
        if(this.tripOptions[key][i].key == val) return this.tripOptions[key][i].label;
      }
      
    },

    inventoryBrowser: function() {
      this.getInventoryDataFromApi();
      this.inventoryDialog = true;
    },

    openInventory: function(id) {
      this.inventorySaving = false;
      if(!id || id == 'new') {
        this.inventoryEditing = {};
      } else {
        for(let i = 0; i < this.tripInventory.length; i++) {
          if(this.tripInventory[i]._id == id) this.inventoryEditing = JSON.parse(JSON.stringify(this.tripInventory[i]));
        }
      }
      this.inventoryDialog = true;
    },
    saveInventory: function() {
      let data = {};
      if(!this.inventoryEditing.supplier_id) {
        this.$swal.fire('Supplier Required', 'You must select a supplier');
        return;
      }

      let ignore_keys = [
        '_id',
        'archived',
        'create_date',
        'last_update'
      ];
      for(let i = 0; i < Object.keys(this.inventoryEditing).length; i++) {
        let key = Object.keys(this.inventoryEditing)[i];
        if(key == 'item_retail_price' || key == 'item_tp_price' || key == 'item_tp_purchase_price') {
          data[key] = (!this.inventoryEditing[key] ? 0 : this.inventoryEditing[key]);
        } else if(ignore_keys.indexOf(key) < 0) {
          data[key] = (this.inventoryEditing[key] == null ? '' : this.inventoryEditing[key]);
        }
      }

      this.inventorySaving = true;
      if(!this.inventoryEditing._id) {
        //New
        this.$http.post('inventories', data)
          .then(invResponse => {
            this.tripInventory.push( invResponse.data );
            this.inventoryDialog = false;
          })
          .catch(invError => {
            this.$swal.fire('Error', 'There was an error creating this inventory item');
          }).finally(()=>{ this.inventorySaving = false; });
      } else {
        //Update
        this.$http.patch('inventories/' + this.inventoryEditing._id, data)
          .then(invResponse => {
            let found = false;
            for(let i = 0; i < this.tripInventory.length; i++) {
              if(this.tripInventory[i]._id == invResponse.data._id) {
                found = true;
                this.$set(this.tripInventory, i, invResponse.data);
                break;
              }
            }
            if(!found) this.tripInventory.push( invResponse.data );
            this.inventoryDialog = false;
          })
          .catch(invError => {
            this.$swal.fire('Error', 'There was an error creating this inventory item');
          }).finally(()=>{ this.inventorySaving = false; });
      }
    },
    confirmRemoveInventory: function(inv) {
      this.$swal.fire({
        title: 'Remove from Lookbook?',
        html: 'Are you sure you want to remove<div style="font-weight: 900; margin: 10px auto;">' + inv.item_name + '</div>from the lookbook?',
        confirmButtonText: 'Yes, Remove It',
        cancelButtonText: 'No'
      }).then(result => {
        if(result.value) {
          for(let i = 0; i < this.tripInventory.length; i++) {
            if(this.tripInventory[i]._id == inv._id) {
              this.tripInventory.splice(i, 1);
              break;
            }
          }
        }
      })
    },

    saveLookbook: function() {
      let data = {};
      
      if(this.tripInventory.length <= 0) {
        this.$swal.fire('No Items', 'The lookbook needs at least 1 item to save');
        return;
      }

      data.trip_id = this.trip._id;
      data.user_id = this.trip.user_id;
      data.inventory_id = [];
      for(let i = 0; i < this.tripInventory.length; i++) {
        data.inventory_id.push(this.tripInventory[i]._id);
        
      }
      data.status = this.tripLookbook.status;

      this.lookbookSaving = true;
      /* statsuses
        creating
        styling
        done
      
      data = {
        _id
        inventory_id
        trip_id
        user_selected
        status
        order_id
      }*/

      if(!this.tripLookbook._id) {
        this.$http.post('lookbooks', data)
          .then(lbResponse => {
            this.tripLookbook = lbResponse.data;
            this.$http.patch('trips/' + this.trip._id, {'lookbook_id':lbResponse.data._id})
              .then(tripResponse => {
                this.trip = tripResponse.data;
                this.$toast.fire({title: 'Lookbook Saved'});
              })
              .catch(tripError => {
                this.$swal.fire('Error', 'There was a problem saving the lookbook to the trip');
              });
            
          })
          .catch(lbError => {
            this.$swal.fire('Error', 'There was an error saving the lookbook');
          }).finally(() => { this.lookbookSaving = false });
      } else {
        this.$http.patch('lookbooks/' + this.tripLookbook._id, data)
          .then(lbResponse => {
            this.tripLookbook = lbResponse.data;
            if(!this.trip.lookbook_id) {
              this.$http.patch('trips/' + this.trip._id, {'lookbook_id':lbResponse.data._id})
                .then(tripResponse => {
                  this.trip = tripResponse.data;
                  this.$toast.fire({title: 'Lookbook Saved'});
                })
                .catch(tripError => {
                  this.$swal.fire('Error', 'There was a problem saving the lookbook to the trip');
                });
            } else {
              this.$toast.fire({title: 'Lookbook Saved'});
            }
          })
          .catch(lbError => {
            this.$swal.fire('Error', 'There was an error saving the lookbook');
          }).finally(() => { this.lookbookSaving = false });
      }

      
    },

    inventoryInLookbook: function(id) {
      for(let i = 0; i < this.tripInventory.length; i++) {
        if(this.tripInventory[i]._id == id) return true;
      }
      return false;
    },
    toggleLookbookSelection: function(inventory) {
      let exists = this.inventoryInLookbook(inventory._id)
      
      if(exists) {
        //Deselect
        this.confirmRemoveInventory(inventory);
      } else {
        //Select
        this.tripInventory.push(inventory);

      }

      
    },

    filterInventory: function(clear) {
      if(clear) this.inventoryIdSearch = null;
      this.getInventoryDataFromApi();
    },

    updateOrder: function() {
      if(!this.tripOrder) return;

      this.orderSaving = true;

      this.$http.patch('orders/' + this.tripOrder._id, {
        status: this.tripOrder.status,
        trip_id: this.trip._id,
        lookbook_id: this.tripLookbook._id,
        user_id: this.tripUser._id
      })
        .then(oResponse => {
          this.tripOrder = oResponse.data;

          this.$http.patch('trips/' + this.trip._id, {tracking_number: this.trip.tracking_number})
            .then(tResponse => {
              this.trip = { ...this.trip, ...tResponse.data};
            })
            .catch(tResponse => {
              this.$swal.fire('Error', 'There was an error updating the tracking number');
            })
            .finally( () => {
              this.orderSaving = false;
            })
        })
        .catch(oResponse => {
          this.$swal.fire('Error', 'There was an error updating the order status');
          this.orderSaving = false;
        })
    },

    onScroll: function(e) {
      this.showScrollUp = (window.pageYOffset >= 250);
    },
    scrollTo: function(pos = 0) {
      this.$vuetify.goTo(pos, {duration: 300, offset: 0, easing: 'easeInOutCubic'});
    },

    copyTripUrl: function() {
      let ref = this;
      let url = process.env.VUE_APP_URL + 'trip/' + this.trip._id;
      this.$copyText(url).then(function (e) {
        ref.$toast.fire('<b>' + url + '<b> - Copied to clipboard');
      }, function (e) {
        ref.$toast.fire({
          title: 'Could not copy trip url to clipboad',
          type: 'error'
        });
      });
    }

  },
  
}
</script>

<style lang="scss">


  .inventoryInLookbook {
    border: 2px solid #000;
  }
  .tripAdminHeader {
    position: fixed; 
    top: 0px; 
    left: 0px; 
    right: 0px; 
    width: 100%;
    z-index: 3;
  }

</style>
